<template>
  <div class="about">
    <h1>This is an about page. You get it?</h1>
    <div class="summernote"><p><b>This</b> is cool</p></div>
  </div>
</template>


<script>
import $script from "scriptjs";
import $ from "jquery";
import bootstrap from "bootstrap";

require("summernote/dist/summernote-bs4.css");
require("../assets/report-template-style.css");

export default {
  created() {
    $script(
      [
        "https://cdnjs.cloudflare.com/ajax/libs/popper.js/1.11.0/umd/popper.min.js",
        "https://cdnjs.cloudflare.com/ajax/libs/summernote/0.8.10/summernote-bs4.js"
      ],
      "bundle"
    );

    $script.ready("bundle", function() {
      $script(
        [
          // 'https://rawgit.com/creativeprogramming/summernote-addclass/master/summernote-ext-addclass.js',
          // '../assets/summernote-ext-addclass.js'
        ],
        "bundle2"
      );
    });
  },

  mounted() {
    $script.ready("bundle", function() {
      $(".summernote").summernote({
        buttons: {},
        toolbar: [
          [
            "fontstyle",
            [
              "fontsize",
              "bold",
              "italic",
              "ul",
              "ol",
              "superscript",
              "subscript"
            ]
          ],
          ["extra", ["table"]],
          ["misc", ["undo", "redo"]]
        ]
      });
    });
  }
};
</script>